import React, { useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import { Bloglistdata } from "../Data/Blogdata/Blogdata";
import AnimationCommon from "../common/AnimationCommon";
import CustomBreadcrumb from "../common/Breadcrumb";
import Footer from "../components/footer";
import BlogItem from "./BlogItem";
import BlogNav from "./BlogNav";
import Sidebar from "./Sidebar";

const BlogRightSidebar = () => {
  useEffect(() => {
    document.body.classList.remove("landing-page");
    document.body.classList.add("inner-page");
  }, []); 

  return (
    <div>
    <BlogNav/>
      <div className='page-margin'>
        <CustomBreadcrumb items={"right-sidebar"} />
        <section className='blog-page'>
          <Container>
            <Row>
              <Col sm={12} md={8} lg={9}>
                <Row className='blog-list'>
                  {Bloglistdata.map((blog, index) => (
                    <BlogItem key={index} title={blog.title} author={blog.author} date={blog.date} commentsCount={blog.commentsCount} views={blog.views} content={blog.content} imageUrl={blog.imageUrl} detailsLink={blog.detailsLink} />
                  ))}
                </Row>
              </Col>
              <Sidebar align='last'/>
            </Row>
          </Container>
          <AnimationCommon />
        </section>
        <Footer />
      </div>
    </div>
  );
};

export default BlogRightSidebar;
